<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style="border-radius: 5px !important; padding-left: 0px"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-nav>
            <b-button @click="previousFFView" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true"
                >skip_previous</md-icon
              >Back
            </b-button>
          </b-navbar-nav>

          <b-navbar-brand center>{{
            portType == "Icd"
              ? "Handover to Rail"
              : " Gate-In at Terminal By Road"
          }}</b-navbar-brand>

          <b-navbar-nav class="ml-auto"></b-navbar-nav>
        </b-navbar>

        <b-card class="formCard">
          <b-card-text>
            <div class="mt-2">
              <!-- <b-button
                size="sm"
                variant="outline-info"
                :class="visible ? null : 'collapsed'"
                :aria-expanded="visible ? 'true' : 'false'"
                aria-controls="collapse-4"
                @click="visible = !visible"
              >Hide Details</b-button>-->
              <!-- <b-collapse id="collapse-4" v-model="visible" class="mt-2">
                <b-card class="HeaderMastBanner">
                  <md-layout gutter>
                    <md-layout md-flex="35">
                      <md-layout md-flex="100">
                        <b>
                          Client Name : {{mainEntryData[0].clientName}}
                          <br>
                        </b>
                        <b>Assignment No. : {{mainEntryData[0].ffExportFclSeries}}</b>
                      </md-layout>
                    </md-layout>
                    <md-layout md-flex="25">
                      <md-layout md-flex="100">
                        <b>Stuffing Type : {{mainEntryData[0].stuffingType}}</b>
                        <br>
                        <b>FF Activity : {{mainEntryData[0].containerInfo}}</b>
                      </md-layout>
                    </md-layout>
                    <md-layout md-flex="40">
                      <md-layout md-flex="100">
                        <b>Shipping Line : {{mainEntryData[0].shippingLine}}</b>
                      </md-layout>
                    </md-layout>
                  </md-layout>
                </b-card>
              </b-collapse>     <hr> -->
            </div>

            <div
              class="phone-viewport mt-3"
              id="vehicleBooking"
              v-if="portType == 'Icd'"
            >
              <md-list>
                <md-list-item
                  style="background: darkcyan !important"
                  id="showVisibility"
                  class="md-button-color-toggle"
                  v-bind:class="
                    handover.handoverToRailId == '' ? 'md-active' : ''
                  "
                  @click="showOverflow"
                >
                  <span style="color: white">Handover to Rail</span>

                  <md-list-expand>
                    <b-card>
                      <md-list>
                        <md-layout md-gutter class="gutr">
                          <md-layout md-flex="15">
                            <h5>
                              <b-badge>Handover Party *</b-badge>
                            </h5>
                            <span class="error" v-if="!handover.handoverTo">{{
                              errorList.handoverTo
                            }}</span>
                          </md-layout>
                        </md-layout>
                        <md-layout md-gutter class="gutr">
                          <md-layout md-flex="15">
                            <md-radio
                              id="permitted"
                              name="permitted1"
                              md-value="HandOverToIcd"
                              v-model="handover.handoverTo"
                              class="md-primary margn-0px"
                              >HandOver To ICD</md-radio
                            >
                          </md-layout>

                          <md-layout md-flex="15">
                            <md-radio
                              id="permitted2"
                              name="permitted2"
                              v-model="handover.handoverTo"
                              md-value="HandOverToCFS"
                              class="md-primary margn-0px"
                              >HandOver To CFS</md-radio
                            >
                          </md-layout>
                        </md-layout>

                        <md-layout md-gutter class="labelMargtop">
                          <md-layout
                            md-flex="40"
                            md-flex-small="100"
                            v-if="handover.handoverTo == 'HandOverToCFS'"
                          >
                            <label for="clientId">CFS Name</label>

                            <model-list-select
                              :list="cfsList"
                              id="cfs"
                              v-model="handover.cfsId"
                              option-value="pickupId"
                              option-text="pickupLocation"
                              placeholder="Select CFS"
                            ></model-list-select>
                          </md-layout>
                        </md-layout>
                        <md-layout md-gutter class="labelMargtop">
                          <md-layout md-flex="15">
                            <label>LEO Date</label>
                            <date-picker
                              :format="selectDateFormat"
                              lang="en"
                              v-model="handover.leoDate"
                              id="date"
                            ></date-picker>
                          </md-layout>
                          <md-layout md-flex="5"></md-layout>
                          <md-layout md-flex="20">
                            <label>Handover Date *</label>
                            <date-picker
                              :format="selectDateFormat"
                              lang="en"
                              v-model="handover.handoverDate"
                              id="date"
                            ></date-picker>
                            <span class="error" v-if="!handover.handoverDate">{{
                              errorList.handoverDate
                            }}</span>
                          </md-layout>
                          <md-layout md-flex="5"></md-layout>

                          <md-layout md-flex="20">
                            <label>TR Submission Date</label>
                            <date-picker
                              v-model="handover.trSubmitDateHandover"
                              lang="en"
                              type="datetime"
                              format="YYYY-MM-DD"
                              :minute-step="1"
                            ></date-picker>
                          </md-layout>
                          <md-layout md-flex="5"></md-layout>

                          <md-layout md-flex="20">
                            <md-layout md-flex="100">
                              <label>TR Submission Mode</label>

                              <model-list-select
                                :list="trModeList"
                                v-model="handover.trSubmitModeHandover"
                                option-value="tV"
                                option-text="tT"
                                placeholder="Select Mode "
                              ></model-list-select>
                            </md-layout>
                          </md-layout>
                        </md-layout>
                        <md-layout
                          md-gutter
                          class="gutr"
                          v-if="handover.trSubmitModeHandover == 'Online'"
                        >
                          <md-layout md-flex="100">
                            <md-layout md-flex="100">
                              <label>Enter Details</label>
                              <b-form-textarea
                                :formatter="capitalizeAll"
                                id="shippingBillNo"
                                name="shippingBillNo"
                                v-model="handover.trModeOnline"
                              ></b-form-textarea>
                            </md-layout>
                          </md-layout>
                        </md-layout>
                        <b-card
                          class="mt-3"
                          style="background: whiteSmoke"
                          v-if="isPridel == 'Pridel'"
                        >
                          <b-card-text>
                            <md-layout md-gutter class="mt-2">
                              <md-layout md-flex="90">
                                <h5>
                                  <b-badge
                                    >Payment Details For Payment done Through
                                    Pridel PDA</b-badge
                                  >
                                </h5>
                              </md-layout>
                            </md-layout>
                            <md-layout md-gutter>
                              <md-layout md-flex="35">
                                <md-layout md-flex="100">
                                  <label>Shipping Bill No *</label>
                                  <b-form-input
                                    :formatter="capitalizeAll"
                                    id="shippingBillNo"
                                    name="shippingBillNo"
                                    v-model="handover.shippingBillNo"
                                  ></b-form-input>
                                </md-layout>
                                <span
                                  class="error"
                                  v-if="
                                    !handover.shippingBillNo &&
                                    isPridel == 'Pridel'
                                  "
                                  >{{ errorList.shippingBillNo }}</span
                                >
                              </md-layout>
                              <md-layout md-flex="5"></md-layout>
                              <md-layout md-flex="30">
                                <md-layout md-flex="100">
                                  <label>Receipt No *</label>
                                  <b-form-input
                                    :formatter="capitalizeAll"
                                    id="receiptNo"
                                    name="receiptNo"
                                    v-model="handover.receiptNo"
                                  ></b-form-input>
                                </md-layout>
                                <span
                                  class="error"
                                  v-if="
                                    !handover.receiptNo && isPridel == 'Pridel'
                                  "
                                  >{{ errorList.receiptNo }}</span
                                >
                              </md-layout>
                              <md-layout md-flex="5"></md-layout>
                              <md-layout md-flex="25">
                                <md-layout md-flex="100">
                                  <label>Ammount Paid (In Rs)</label>
                                  <b-form-input
                                    :formatter="capitalizeAll"
                                    id="ammountPaid"
                                    name="ammountPaid"
                                    v-model="handover.ammountPaid"
                                  ></b-form-input>
                                </md-layout>
                              </md-layout>
                            </md-layout>

                            <md-layout md-gutter>
                              <md-layout md-flex="15">
                                <label>Date Of Payment :</label>
                              </md-layout>
                              <md-layout md-flex="5"></md-layout>
                              <md-layout md-flex="15">
                                <label>Time Of Payment * :</label>
                              </md-layout>
                            </md-layout>
                            <md-layout md-gutter>
                              <md-layout md-flex="15">
                                <date-picker
                                  :format="selectDateFormat"
                                  lang="en"
                                  v-model="handover.paymentDate"
                                  id="date"
                                ></date-picker>
                                <span
                                  class="error"
                                  v-if="
                                    !handover.paymentDate &&
                                    isPridel == 'Pridel'
                                  "
                                  >{{ errorList.paymentDate }}</span
                                >
                              </md-layout>
                              <md-layout md-flex="5"></md-layout>
                              <md-layout md-flex="15">
                                <DatePicker
                                  v-model="handover.paymentTime"
                                  lang="en"
                                  type="time"
                                  format="HH:mm"
                                  placeholder="Select Time"
                                  :minute-step="1"
                                ></DatePicker>
                              </md-layout>
                              <md-layout md-flex="10"></md-layout>
                            </md-layout>
                          </b-card-text>
                        </b-card>

                        <md-layout md-gutter class="mrgtop-button mt-4">
                          <md-layout md-flex="40">
                            <b-button
                              class="mt-3"
                              variant="primary"
                              id="addButtonLoader223"
                              @click="addHandoverToRail"
                              style="z-index: 0"
                            >
                              Save & Proceed To Rail Out</b-button
                            >
                            <md-spinner
                              md-indeterminate
                              id="loader223"
                              style="display: none"
                            ></md-spinner>
                          </md-layout>
                        </md-layout>
                      </md-list>
                    </b-card>
                  </md-list-expand>
                </md-list-item>
              </md-list>
            </div>

            <div
              class="phone-viewport mt-3"
              id="railOut"
              v-if="handover.handoverToRailId != '' || portType == 'Sea_Port'"
            >
              <md-list>
                <md-list-item
                  style="background: darkcyan !important; overflow: visible"
                  class="md-button-color-toggle md-active"
                >
                  <span style="color: white">{{
                    portType == "Icd"
                      ? "Rail Out "
                      : " Gate-In at Terminal By Road"
                  }}</span>

                  <md-list-expand>
                    <md-list>
                      <div class="table-responsive mt-4">
                        <table
                          class="table table-sm table-bordered table-hover"
                        >
                          <tbody>
                            <tr>
                              <th scope="col">
                                <b-form-checkbox
                                  id="checkbox-1"
                                  @input="sameForAll"
                                  v-model="sameForAllSelected"
                                  name="checkbox-1"
                                  value="1"
                                  unchecked-value="0"
                                >
                                </b-form-checkbox>
                              </th>
                              <th scope="col">Container</th>
                              <th
                                v-if="portType != 'Sea_Port'"
                                style="width: 200px"
                                scope="col"
                              >
                                {{
                                  portType == "Sea_Port"
                                    ? "TR Submission Mode"
                                    : "Train No."
                                }}
                                <!-- <br>
<span class="error"> Same for all</span>
 <b-form-checkbox
style="margin-top: -22px;
    margin-left: 90px;"
class="checkBox"
      id="checkbox-1"
      @input="sameForAll('TR_TRAIN')"
      name="checkbox-1"
      value="accepted"
      unchecked-value="not_accepted"
    >
    
    </b-form-checkbox> -->
                              </th>
                              <th
                                v-if="portType == 'Sea_Port'"
                                style="width: 250px"
                                scope="col"
                              >
                                TR Submission
                              </th>
                              <th style="width: 200px" scope="col">
                                {{
                                  portType == "Sea_Port"
                                    ? "Gate-In Type"
                                    : "Wagon  No."
                                }}
                              </th>

                              <th style="width: 200px" scope="col">
                                {{
                                  portType == "Sea_Port"
                                    ? "Gate-In Date"
                                    : "Train Departure Dt. & Time"
                                }}
                              </th>
                              <th style="width: 150px" scope="col">
                                {{
                                  portType == "Sea_Port"
                                    ? "Date of Container Arrival at Port"
                                    : "Train Arrival Dt. & Time At Port"
                                }}
                              </th>
                              <th
                                v-if="portType == 'Sea_Port'"
                                style="width: 150px"
                                scope="col"
                              >
                                Vessel & Voyage Details
                              </th>

                              <th
                                v-if="portType == 'Sea_Port'"
                                style="width: 150px"
                                scope="col"
                              >
                                Other Dates
                              </th>
                            </tr>

                            <tr
                              v-for="(item, indx) in containerNoList"
                              :key="indx"
                            >
                              <th scope="row">
                                {{ indx + 1 }} {{ item.checked }} <br /><br />
                                <b-form-checkbox
                                  v-model="item.checked"
                                  value="1"
                                  unchecked-value="0"
                                >
                                </b-form-checkbox
                                ><br />
                                <b-button
                                  v-if="item.checked == '1'"
                                  @click="renderForAll(indx)"
                                  size="sm"
                                  variant="light"
                                  >Replicate</b-button
                                >
                              </th>
                              <th scope="row">
                                {{
                                  item.ContainerNo
                                    ? item.ContainerNo
                                    : item.containerNo
                                }}<br /><small style="visibility: hidden">{{
                                  item.ffExecutionContainerId
                                }}</small>
                              </th>

                              <td v-if="portType != 'Sea_Port'">
                                <b-form-input
                                  :formatter="capitalizeAll"
                                  size="sm"
                                  v-model="item.trainNo"
                                ></b-form-input>
                              </td>
                              <td v-if="portType == 'Sea_Port'">
                                <small> TR Submission Mode</small>
                                <model-list-select
                                  :list="trModeList"
                                  v-model="item.trSubmitMode"
                                  option-value="tV"
                                  option-text="tT"
                                  placeholder="Select Mode "
                                ></model-list-select>
                                <!-- <span v-if="item.trSubmitMode == 'Online'">
                                    <br />

                                    <b-form-textarea :formatter="capitalizeAll"
                                      v-if="item.trSubmitMode == 'Online'"
                                      placeholder="Enter Details"
                                      id="shippingBillNo"
                                      name="shippingBillNo"
                                      v-model="item.trModeOnline"
                                    ></b-form-textarea>

                                  </span> -->
                                <small> TR Submission Date</small>
                                <date-picker
                                  style="width: 150px"
                                  v-model="item.trSubmitDate"
                                  lang="en"
                                  format="YYYY-MM-DD"
                                  :minute-step="1"
                                ></date-picker>
                              </td>

                              <td v-if="portType == 'Sea_Port'">
                                <model-list-select
                                  :list="gateInTypeList"
                                  v-model="item.gateInType"
                                  option-value="gV"
                                  option-text="gT"
                                  placeholder="Select Type"
                                ></model-list-select>
                              </td>
                              <td v-else>
                                <b-form-input
                                  :formatter="capitalizeAll"
                                  size="sm"
                                  v-model="item.wagonNo"
                                ></b-form-input>
                              </td>
                              <td>
                                <date-picker
                                  style="width: 200px"
                                  v-if="portType == 'Sea_Port'"
                                  lang="en"
                                  v-model="item.gateInTypeDate"
                                  type="datetime"
                                  format="YYYY-MM-DD hh:mm a "
                                  :minute-step="1"
                                ></date-picker>
                                <date-picker
                                  v-else
                                  v-model="item.trainDepartDate"
                                  lang="en"
                                  type="datetime"
                                  format="YYYY-MM-DD hh:mm a"
                                  :minute-step="1"
                                ></date-picker>
                              </td>
                              <td>
                                <date-picker
                                  style="width: 150px"
                                  v-if="portType == 'Sea_Port'"
                                  v-model="item.containerArivalAtPortDate"
                                  lang="en"
                                  type="datetime"
                                  format="YYYY-MM-DD"
                                  :minute-step="1"
                                ></date-picker>
                                <date-picker
                                  v-else
                                  lang="en"
                                  v-model="item.trainArriveDate"
                                  type="datetime"
                                  format="YYYY-MM-DD hh:mm a"
                                  :minute-step="1"
                                ></date-picker>
                              </td>
                              <td v-if="portType == 'Sea_Port'">
                                <small>Vessel</small>
                                <b-form-input
                                  :formatter="capitalizeAll"
                                  style="width: 200px"
                                  size="sm"
                                  v-model="item.vesselName"
                                ></b-form-input>

                                <small>Voyage</small>
                                <b-form-input
                                  :formatter="capitalizeAll"
                                  style="width: 200px"
                                  size="sm"
                                  v-model="item.vesselVoyage"
                                ></b-form-input>
                              </td>

                              <td v-if="portType == 'Sea_Port'">
                                <small>Vessel Gate-Open Date</small>
                                <date-picker
                                  style="width: 150px"
                                  v-model="item.vesselEta"
                                  lang="en"
                                  type="datetime"
                                  format="YYYY-MM-DD"
                                  :minute-step="1"
                                ></date-picker>
                                <small>Vessel ETD</small>
                                <date-picker
                                  style="width: 150px"
                                  v-model="item.vesselEtd"
                                  lang="en"
                                  type="datetime"
                                  format="YYYY-MM-DD"
                                  :minute-step="1"
                                ></date-picker>
                                <small>LEO Date</small>
                                <date-picker
                                  style="width: 150px"
                                  v-model="item.gateOutDate"
                                  lang="en"
                                  type="datetime"
                                  format="YYYY-MM-DD"
                                  :minute-step="1"
                                ></date-picker>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>

                      <!-- 

                        <div v-if="getContainerNoData.length > 0 || railout.railOutTableId!=''">
                          <md-layout md-gutter class="labelMargtop">
                          

                            <md-layout md-flex="40">
                              <label
                                for="shippingId"
                                v-if="railout.railOutTableId==''"
                              >Container No *</label>
                              <model-list-select
                                v-if="railout.railOutTableId==''"
                                :list="containerNoList"
                                v-model="railout.ffExecutionContainerId"
                                option-value="ffExecutionContainerId"
                                option-text="containerNo"
                                placeholder="Select Container No"
                              ></model-list-select>
                              <md-layout md-flex="100" v-else>
                                <label>Container No *</label>
                                <b-form-input :formatter="capitalizeAll" v-model="railout.containerNo" disabled></b-form-input>
                              </md-layout>
                              <span
                                class="error"
                                v-if="!railout.containerNo"
                              >{{errorRail.containerNo}}</span>
                            </md-layout>
                          </md-layout>
                          <div v-if="handover.handoverToRailId!=''">
                            <md-layout md-gutter class="labelMargtop">
                            
                              <md-layout md-flex="40">
                                <md-layout md-flex="100">
                                  <label>Train No</label>
                                  <b-form-input :formatter="capitalizeAll"
                                    id="trainNo"
                                    name="trainNo"
                                    v-model="railout.trainNo"
                                  ></b-form-input>
                                </md-layout>
                              </md-layout>

                              <md-layout md-flex="5"></md-layout>
                              <md-layout md-flex="55">
                                <md-layout md-flex="100">
                                  <label>Wagon No</label>
                                  <b-form-input :formatter="capitalizeAll"
                                    id="wagonNo"
                                    name="wagonNo"
                                    v-model="railout.wagonNo"
                                  ></b-form-input>
                                </md-layout>
                              </md-layout>
                            </md-layout>

                            <md-layout md-gutter class="labelMargtop">
                            

                              <md-layout md-flex="20">
                                <label>Train Departure Date & Time</label>
                                <date-picker
                                  v-model="railout.trainDepartDate"
                                  lang="en"
                                  type="datetime"
                                  format="YYYY-MM-DD hh:mm a"
                                  :minute-step="1"
                                ></date-picker>
                            
                              </md-layout>

                              <md-layout md-flex="5"></md-layout>
                              <md-layout md-flex="25">
                                <label>Train Arrival Date & Time At Port</label>
                                <date-picker
                                  lang="en"
                                  v-model="railout.trainArriveDate"
                                  type="datetime"
                                  format="YYYY-MM-DD hh:mm a"
                                  :minute-step="1"
                                ></date-picker>
                            
                              </md-layout>
                            </md-layout>
                          </div>
                          <div v-if="portType=='Sea_Port'">
                            <md-layout md-gutter class="labelMargtop">
                              

                              <md-layout md-flex="25">
                                <label>Date of Container Arrival at Port</label>
                                <date-picker
                                  v-model="railout.containerArivalAtPortDate"
                                  lang="en"
                                  type="datetime"
                                  format="YYYY-MM-DD"
                                  :minute-step="1"
                                ></date-picker>
                              </md-layout>
                              <md-layout md-flex="5"></md-layout>

                              <md-layout md-flex="20">
                                <label>TR Submission Date</label>
                                <date-picker
                                  v-model="railout.trSubmitDate"
                                  lang="en"
                                  type="datetime"
                                  format="YYYY-MM-DD"
                                  :minute-step="1"
                                ></date-picker>
                              </md-layout>
                              <md-layout md-flex="5"></md-layout>

                              <md-layout md-flex="30">
                                <md-layout md-flex="100">
                                  <label>TR Submission Mode</label>
                                  <model-list-select
                                    :list="trModeList"
                                    v-model="railout.trSubmitMode"
                                    option-value="tV"
                                    option-text="tT"
                                    placeholder="Select Mode "
                                  ></model-list-select>
                                </md-layout>
                              </md-layout>
                            </md-layout>

                            <md-layout md-gutter class="labelMargtop">
                            

                              <md-layout md-flex="35">
                                <label for="ccType">Gate-In Type</label>
                                <model-list-select
                                  :list="gateInTypeList"
                                  v-model="railout.gateInType"
                                  option-value="gV"
                                  option-text="gT"
                                  placeholder="Select GateIn Type"
                                ></model-list-select>
                              </md-layout>
                            </md-layout>
                            <md-layout md-gutter class="labelMargtop">
                          
                         
                              <md-layout md-flex="15">
                                <label>Gate-In Date</label>
                                <date-picker
                                  lang="en"
                                  v-model="railout.gateInTypeDate"
                                  type="datetime"
                                  format="YYYY-MM-DD hh:mm a "
                                  :minute-step="1"
                                ></date-picker>
                              </md-layout>
                             
                            
                            </md-layout>
                            <md-layout md-gutter class="labelMargtop">
                            
                              <md-layout md-flex="45">
                                <md-layout md-flex="100">
                                  <label>Vessel Name</label>
                                  <b-form-input :formatter="capitalizeAll"
                                    id="trainNo"
                                    name="trainNo"
                                    v-model="railout.vesselName"
                                  ></b-form-input>
                                </md-layout>
                              </md-layout>

                              <md-layout md-flex="5"></md-layout>
                              <md-layout md-flex="50">
                                <md-layout md-flex="100">
                                  <label>Vessel Voyage</label>
                                  <b-form-input :formatter="capitalizeAll"
                                    id="vesselVoyage"
                                    name="vesselVoyage"
                                    v-model="railout.vesselVoyage"
                                  ></b-form-input>
                                </md-layout>
                              </md-layout>
                            </md-layout>
                            <md-layout md-gutter class="labelMargtop">
                       
                              <md-layout md-flex="15">
                                <label>Vessel Gate-Open Date</label>
                                <date-picker
                                  lang="en"
                                  v-model="railout.vesselEta"
                                  type="datetime"
                                  format="YYYY-MM-DD "
                                  :minute-step="1"
                                ></date-picker>
                              </md-layout>
                              <md-layout md-flex="5"></md-layout>
                              <md-layout md-flex="15">
                                <label>Vessel ETD</label>
                                <date-picker
                                  lang="en"
                                  v-model="railout.vesselEtd"
                                  type="datetime"
                                  format="YYYY-MM-DD "
                                  :minute-step="1"
                                ></date-picker>
                              </md-layout>
                            </md-layout>
 <md-layout md-gutter class="labelMargtop">

                              <md-layout md-flex="15">
                                <label>LEO Date</label>
                                <date-picker
                                  lang="en"
                                  v-model="railout.gateOutDate"
                                  type="datetime"
                                  format="YYYY-MM-DD hh:mm a "
                                  :minute-step="1"
                                ></date-picker>
                              </md-layout>
 </md-layout>
                          </div>

                         
                        </div> -->
                      <!-- <div class=" mt-3" v-if="railOutTableArrayList.length>0">
                      
                            <h5 >
                              <b-badge>{{ (portType=='Icd' && (stuffingType == 'warehouseStuffing' || stuffingType == 'factoryStuffing') )?'Rail Out Details':' Gate-In at Terminal By Road Details'}}</b-badge>
                            </h5>
                         
                         
                          <div class="box-body">
                            <table id="railOuttariff" class="table table-bordered ">
                              <thead>
                                <tr>
                                  <th>Sr No.</th>
                                  <th>Container No</th>
                                  
                                </tr>
                              </thead>
                              <tbody>
                                <tr></tr>
                                <tr v-for="(item,index) in railOutTableArrayList" :key="index">
                                  <td>{{index+1}}</td>
                                  <td
                                    @click="editRailTable(item)"
                                    class="showMoreData"
                                  >{{item.containerNo}}</td>
                                 
                                </tr>
                              </tbody>
                            </table>
                          </div>

                     
                        </div> -->
                      <md-layout md-gutter class="mrgtop-button gutr">
                        <md-layout md-flex="15">
                          <b-button
                            class="mt-3"
                            variant="primary"
                            id="addButtonLoader116"
                            @click="addRailOutTables"
                            >Save & Submit</b-button
                          >
                          <md-spinner
                            md-indeterminate
                            id="loader116"
                            style="display: none"
                          ></md-spinner>
                        </md-layout>
                      </md-layout>
                      <md-layout md-gutter class="gutr">
                        <md-layout md-flex="30">
                          <b-button
                            class="mt-3"
                            variant="primary"
                            id="addButtonLoader116"
                            @click="showSailFPOD"
                            >Save & Proceed to Sail and FPOD</b-button
                          >
                          <md-spinner
                            md-indeterminate
                            id="loader116"
                            style="display: none"
                          ></md-spinner>
                        </md-layout>
                      </md-layout>
                    </md-list>
                  </md-list-expand>
                </md-list-item>
              </md-list>
            </div>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>
    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop22"
      @close="onClose22"
    ></md-dialog-alert>

    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="onClose6"
      ref="addPop6"
    ></md-dialog-confirm>

    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPopData"
    ></md-dialog-alert>

    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop11212"
      @close="onClose11212"
    ></md-dialog-alert>
  </div>
</template>


<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import { ModelListSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import { globalPermissionStatus } from "../../helper/collection";

export default {
  beforeMount() {
    if (
      globalPermissionStatus("Sea Freight") &&
      this.$sessionsStorage.get("editFFExecutionId") != undefined &&
      this.$sessionsStorage.get("editFFExecutionId") != ""
    ) {
      this.$store.dispatch("setCurrentRoute", "/freightForward/handoverToRail");
      this.getServicesData();
      this.getData();
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },
  watch: {},
  data() {
    return {
      trackingId: "",
      selectDateFormat,
      cfsList: [],
      gateInTypeList: [
        {
          gV: "1",
          gT: "Buffer",
        },
        {
          gV: "2",
          gT: "Ground Rent",
        },
        {
          gV: "3",
          gT: "Normal",
        },
        {
          gV: "4",
          gT: "Via ",
        },
      ],
      trModeList: [
        {
          tV: "Online",
          tT: "Online",
        },
        {
          tV: "Handover_to_Line_Surveyor",
          tT: "Handover to Line / Surveyor",
        },
        {
          tV: "Handover_to_SL_City_office",
          tT: "Handover to S/L City office",
        },
      ],
      isLoading: false,
      visible: true,
      alert: {
        content:
          this.$sessionsStorage.get("editExportFCLId") != "" &&
          this.$sessionsStorage.get("editExportFCLId") != undefined
            ? "Data Updated Succesfully"
            : "Added Succesfully",
        ok: "ok",
      },

      handover: {
        cfsId: "",
        trModeOnline: "",
        trSubmitDateHandover: "",
        trSubmitModeHandover: "",
        leoDate: "",
        handoverToRailId: "",
        ffExportFclId: this.$sessionsStorage.get("editExportFCLId"),
        ffBookingId: this.$sessionsStorage.get("editFFBookingId"),
        ffExcutionId: this.$sessionsStorage.get("editFFExecutionId"),
        handoverTo: "",
        handoverDate: "",
        shippingBillNo: "",
        receiptNo: "",
        ammountPaid: "",
        paymentDate: "",
        paymentTime: "",
        stuffingType: "",
      },
      errorList: {
        handoverTo: "",
        handoverDate: "",
        shippingBillNo: "",
        paymentDate: "",
        receiptNo: "",
      },
      showVisible: false,
      showVisibleRail: false,
      railout: {
        trSubmitMode: "",
        trSubmitDate: "",
        portInDate: "",
        gateOutDate: "",
        cfsName: "",
        railOutTableId: "",
        ffExecutionContainerId: "",
        containerNo: "",
        trainDepartDate: "",
        trainNo: "",
        wagonNo: "",
        trainDepartTime: "",
        trainArriveDate: "",
        containerArivalAtPortDate: "",
        gateInType: "",
        gateInTypeDate: "",
        vesselName: "",
        vesselVoyage: "",
        vesselEta: "",
        vesselEtd: "",
      },

      removerailoutVmodel: {
        railOutTableId: "",
        ffExecutionContainerId: "",
        containerNo: "",
      },
      errorRail: {
        ffExecutionContainerId: "",
        // trainNo: "",
        // wagonNo: "",
        // trainArriveDate: "",
        // trainDepartDate: ""
      },

      arrayRailError: [
        "Select Container No",
        "Enter train No",
        "Enter wagon No",
        "Select Arrival Date",
        "Select Departure Date",
      ],
      stuffingType: "",
      railoutMain: {
        ffRailOutId: "",
        railOutTableId: "",
        handoverToRailId: "",
        ffExportFclId: this.$sessionsStorage.get("editExportFCLId"),
        ffExcutionId: this.$sessionsStorage.get("editFFExecutionId"),
        ffBookingId: this.$sessionsStorage.get("editFFBookingId"),
        stuffingType: "",
      },
      railOutTableArray: [],
      deleteId: "",

      transhipmentArray: [],
      getPortData: ["Agra"],

      error: {
        clientNameError: "",
        toPortError: "",
        fromPortError: "",
        transhipmentNameError: "",
        addOneTranError: "",
      },
      getContainerNoData: [],
      isPridel: "",
      portType: "",
      getCLientData: ["gfdg"],
      showSegmentArray: [],
      mainEntryData: [],
      driverNameDetail: ["iji"],
      editVar: {
        Inputval:
          this.$sessionsStorage.get("editExportFCLId") != "" &&
          this.$sessionsStorage.get("editExportFCLId") != undefined
            ? "Update"
            : "Add",
        FormVal:
          this.$sessionsStorage.get("editExportFCLId") != "" &&
          this.$sessionsStorage.get("editExportFCLId") != undefined
            ? "Update"
            : "New",
      },
      commodityListName: [],
      getShippingLineData: ["zim"],
      getlocationListData: ["agra"],
      validate: true,
      validateRail: true,
      clientNameError: "",
      addDriverError1: "",
      addTruckError4: "",
      sameForAllSelected: "",
    };
  },

  mounted() {},
  beforeDestroy() {},
  destroyed() {},
  components: {
    DatePicker,
    ModelListSelect,
    // Loading,
    CustomLoader,
  },
  computed: {
    railOutTableArrayList() {
      return this.railOutTableArray;
    },
    containerNoList() {
      return this.getContainerNoData;
    },
    shippingList() {
      return this.getShippingLineData;
    },
    locationList() {
      return this.getlocationListData;
    },
    PortList() {
      return this.getPortData;
    },
    viewDocument() {
      return this.handover.uploadDriverDoc.split(",");
    },
    vehicleMasterList() {
      return this.driverNameDetail;
    },
    commodityList() {
      return this.commodityListName;
    },
  },
  methods: {
    renderForAll(index) {
      let selectedIndex = this.containerNoList[index];

      // let arrySel=this.containerNoList.filter(x=>{

      // return x.checked=='1';
      // });

      // if(arrySel.length>0){
      this.containerNoList.map((x) => {
        if (x.checked == "1" && this.portType == "Sea_Port") {
          x.trSubmitMode = selectedIndex.trSubmitMode;
          x.trSubmitDate = selectedIndex.trSubmitDate;
          x.gateInType = selectedIndex.gateInType;
          x.gateInTypeDate = selectedIndex.gateInTypeDate;
          x.containerArivalAtPortDate = selectedIndex.containerArivalAtPortDate;
          x.vesselName = selectedIndex.vesselName;
          x.vesselVoyage = selectedIndex.vesselVoyage;
          x.vesselEta = selectedIndex.vesselEta;
          x.vesselEtd = selectedIndex.vesselEtd;
          x.gateOutDate = selectedIndex.gateOutDate;
        } else {
          x.trainNo = selectedIndex.trainNo;
          x.wagonNo = selectedIndex.wagonNo;
          x.trainArriveDate = selectedIndex.trainArriveDate;
          x.trainDepartDate = selectedIndex.trainDepartDate;
          x.trainDepartTime = selectedIndex.trainDepartTime;
        }
      });

      //}

      //console.log(selectedIndex)
    },
    sameForAll() {
      if (this.sameForAllSelected == "1") {
        for (let i = 0; i < this.containerNoList.length; i++) {
          this.containerNoList[i].checked = "1";
        }
      } else {
        for (let i = 0; i < this.containerNoList.length; i++) {
          this.containerNoList[i].checked = "0";
        }
      }
    },
    doLoading() {
      this.isLoading = true;
    },
    doLoadingClose() {
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },
    onClose6(type) {
      if (type != "cancel") {
        let paylod = {
          tableName: "ff_railouttable",
          tableId: "railOutTableId",
          isActive: "isRailTableActive",
          tableVal: this.deleteId,
        };
        let options = {
          method: "POST",
          url: `${URL_BASE}/deletePermanent.php`,
          data: JSON.stringify(paylod),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            this.getData();
            this.deleteId = "";
          })
          .catch((error) => {});
      }
    },

    getPortId1(item) {
      this.handover.toportId = item.portId;
    },
    getPortId2(item) {
      this.handover.fromportId = item.portId;
    },
    getPortId3(item) {
      this.transhipment.tentportId = item.portId;
    },

    JqueryFun() {
      return $(function () {
        return $("#railOuttariff").DataTable();
      });
    },
    clientFilter(list, query) {
      return this.getCLientData.filter((x) => {
        return x.clientName.toLowerCase().includes(query.toLowerCase());
      });
    },
    PortFilter(list, query) {
      return this.getPortData.filter((x) => {
        return x.portName.toLowerCase().includes(query.toLowerCase());
      });
    },
    validateFFExport() {
      let validate_new = true;

      if (this.handover.handoverTo == "") {
        $("#handoverTo").focus();
        this.errorList.handoverTo = "Please Select Handover";
        validate_new = false;
      }

      if (this.handover.handoverDate == "") {
        $("#handoverDate").focus();
        this.errorList.handoverDate = "Please Select Handover Date";
        validate_new = false;
      }

      if (this.handover.shippingBillNo == "" && this.isPridel == "Pridel") {
        $("#shippingBillNo").focus();
        this.errorList.shippingBillNo = "Please Enter Shipping Bill No";
        validate_new = false;
      }

      if (this.handover.receiptNo == "" && this.isPridel == "Pridel") {
        $("#receiptNo").focus();
        this.errorList.receiptNo = "Please Enter Receipt  No";
        validate_new = false;
      }

      if (this.handover.paymentDate == "" && this.isPridel == "Pridel") {
        this.errorList.paymentDate = "Please Select Payment Date";
        validate_new = false;
      }

      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },

    editRailTable(item) {
      let array = this.railOutTableArray.filter((x) => {
        return x.railOutTableId == item.railOutTableId;
      });
      Object.keys(this.railout).map((x) => {
        this.railout[x] = array[0][x] || "";
      });
    },
    addHandoverToRail() {
      if (this.mainEntryData.length > 0) {
        this.handover.allModuleId = this.mainEntryData[0].allModuleId;
        this.handover.otherNewContainerFLow = this.mainEntryData[0].otherNewContainerFLow;
      }else{
        this.handover.allModuleId = '';
        this.handover.otherNewContainerFLow = '';
      }
      // console.log("Priyanshu Singh=>",this.handover);return false;
      this.validateFFExport();
      if (this.validate != false) {
        $("#addButtonLoader223").css("display", "none");
        $("#loader223").css("display", "block");

        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_FFSeaExport/addHandoverToRail.php`,
          data: JSON.stringify(this.handover),
          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };

        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              $("#loader223").css("display", "none");
              $("#addButtonLoader223").css("display", "block");
              if (this.handover.handoverToRailId == "") {
                this.alert.content = "Data Added Succesfully";
              } else {
                this.alert.content = "Data Updated Succesfully";
              }
              this.$refs["addPopData"].open();
              this.getData();
            }
          })
          .catch((error) => {});
      }
    },
    onClose11212() {
      if (this.stuffingType == "factoryStuffing") {
        this.$router.push({
          path: "/freightForward/ffExecution",
        });
      } else {
        this.$router.push({
          path: "/freightForward/ffexecutionWareHouse",
        });
      }
    },
    showSailFPOD() {
      // if (
      //   this.getContainerNoData.length > 0 &&
      //   this.railout.railOutTableId == ""
      // ) {
      //   let newArray = this.getContainerNoData.filter(x => {
      //     return (
      //       x.ffExecutionContainerId == this.railout.ffExecutionContainerId
      //     );
      //   });

      //   this.railout.containerNo = newArray[0].containerNo;
      // }

      let new_data = {
        railoutMain: this.railoutMain,
        railout: this.railout,
        containerList: this.containerNoList,
      };

      // this.validateRail1();

      if (this.validateRail != false) {
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_FFSeaExport/addRailOutTable.php`,
          data: JSON.stringify(new_data),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              this.railoutMain.ffRailOutId = data.ffRailOutId;
              if (this.railout.railOutTableId == "") {
                this.alert.content = "Added Succesfully";
              } else {
                this.alert.content = "Data Updated Succesfully";
                this.$refs["addPop22"].open();
              }

              Object.keys(this.railout).map((x) => {
                this.railout[x] = "";
              });
              Object.keys(this.errorRail).map((x) => {
                this.errorRail[x] = "";
              });

              this.getData();
            }
          })
          .catch((error) => {});
      }
      this.$router.push({
        path: "/freightForward/sailFPOD",
      });
    },
    validateTranshipment() {
      let validate_new = true;

      if (this.transhipment.tentPortName == "") {
        $("#tentPortName").focus();
        this.error.tentPortNameError = "Enter Tentative Port Name";
        validate_new = false;
      }

      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },
    validateRail1() {
      let validate_new = true;
      Object.keys(this.errorRail).map((x, index) => {
        if (this.railout[x] == "") {
          this.errorRail[x] = this.arrayRailError[index];
          validate_new = false;
        }
      });

      if (validate_new == false) {
        this.validateRail = false;
      } else {
        this.validateRail = true;
      }
    },

    addRailOutTables() {
      // if (
      //   this.getContainerNoData.length > 0 &&
      //   this.railout.railOutTableId == ""
      // ) {
      //   let newArray = this.getContainerNoData.filter(x => {
      //     return (
      //       x.ffExecutionContainerId == this.railout.ffExecutionContainerId
      //     );
      //   });

      //   this.railout.containerNo = newArray[0].containerNo;
      // }

      let new_data = {
        railoutMain: this.railoutMain,
        railout: this.railout,
        containerList: this.containerNoList,
        otherNewContainerFLow:this.handover.otherNewContainerFLow,
      };

      // this.validateRail1();
      // console.log("Happy SIngh=>",new_data);return false;
      if (this.validateRail != false) {
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_FFSeaExport/addRailOutTable.php`,
          data: JSON.stringify(new_data),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              this.railoutMain.ffRailOutId = data.ffRailOutId;
              if (this.railout.railOutTableId == "") {
                this.alert.content = "Added Succesfully";
              } else {
                this.alert.content = "Data Updated Succesfully";
                this.$refs["addPop22"].open();
              }

              Object.keys(this.railout).map((x) => {
                this.railout[x] = "";
              });
              Object.keys(this.errorRail).map((x) => {
                this.errorRail[x] = "";
              });

              this.getData();
            }
          })
          .catch((error) => {});
      }
    },
    onClose22() {},
    getData() {
      this.doLoading();
      this.railOutTableArray = [];
      let vehicle_drive = {
        containerNo: "containerNo",
        ffExportFclId: this.$sessionsStorage.get("editExportFCLId"),
        ffBookingId: this.$sessionsStorage.get("editFFBookingId"),
        ffExcutionId: this.$sessionsStorage.get("editFFExecutionId"),
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_FFSeaExport/fetchtoHandoverToRailrailOut_NewV3.php`,
        data: JSON.stringify(vehicle_drive),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            // console.log(data);
            if (data.railOutTableData.length > 0) {
              this.getCLientData = data.railOutTableData;
            }
            if (data.FCLDetail.length > 0) {
              this.mainEntryData = data.FCLDetail;
              if (data.FCLDetail[0].allModuleId) {
                this.getTrackingDetails(data.FCLDetail[0].allModuleId);
              }
            }
            this.isPridel = data.FCLDetail[0]["pdaDetail"];
            this.portType = data.FCLDetail[0]["portType"];
            // console.log(data);
            
            if (data.containerDetail.length > 0) {
              this.getContainerNoData = data.containerDetail;
              if (data.railOutTableData.length > 0) {
                this.getContainerNoData = data.railOutTableData;
              } else {
                this.getContainerNoData = data.containerDetail;
              }
            }
            
          // console.log("Priyanshu SIngh=>",data.handOverDetail)
            if (data.handOverDetail.length > 0) {
              Object.keys(this.handover).map((x) => {
                this.handover[x] = data.handOverDetail[0][x] || "";
              });
              this.railoutMain.handoverToRailId =
                this.handover.handoverToRailId;
                // alert(this.handover.length);
            } else {
              this.handover.stuffingType = data.FCLDetail[0]["stuffingType"];
              this.showVisible = true;
              $("#showVisibility").css("overflow", "visible");
            }
              if(data.handOverDetailNew.length>0){
              // console.log("data.handOverDetailNew=>",data.handOverDetailNew)
              // console.log("data.handOverDetail=>",data.handOverDetail)
              this.handover.handoverTo = data.handOverDetailNew[0]['handoverTo'];
              this.handover.handoverDate = data.handOverDetailNew[0]['handoverDate'];
              this.handover.leoDate = data.handOverDetailNew[0]['leoDate'];
              this.handover.trSubmitDateHandover = data.handOverDetailNew[0]['trSubmitDateHandover'];
              this.handover.vesselName = data.handOverDetailNew[0]['vesselName'];
              this.handover.cfsId = data.handOverDetailNew[0]['cfsId'];
              this.handover.otherNewContainerFLow = "1";
            }else{
              this.handover.otherNewContainerFLow = 0;
            }

            if (data.railOutDetail.length > 0) {
              this.showVisibleRail = true;

              Object.keys(this.railoutMain).map((x) => {
                this.railoutMain[x] = data.railOutDetail[0][x] || "";
              });
              if (data.railOutTableData.length > 0) {
                this.railOutTableArray = data.railOutTableData;
                Object.keys(this.railout).map((x) => {
                  this.railout[x] = data.railOutTableData[0][x] || "";
                });

                Object.keys(this.removerailoutVmodel).map((x) => {
                  this.railout[x] = "";
                });
              }
            } else {
              this.railoutMain.stuffingType = data.FCLDetail[0]["stuffingType"];
            }

            this.stuffingType = data.FCLDetail[0]["stuffingType"];
            if (data.cfsData.length > 0) {
              this.cfsList = data.cfsData;
            }
            this.JqueryFun();
            this.doLoadingClose();
          }
        })
        .catch((error) => {});
    },
    getOceanFreightTrackingDetails(ContainerNo) {
      let new_data = {
        allModuleId: this.mainEntryData[0].allModuleId,
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Tracking/getSubscriptionTrackingDetails.php`,
        data: JSON.stringify(new_data),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;

          if (status == 200 && data) {
            if (data.BIdType && data.BIdType.length > 0) {
              this.$sessionsStorage.set("trackingId", data.BIdType[0].id);
              this.trackingId = data.BIdType[0].id;
            } else {
              this.trackingId = "";
            }
            this.getSubscription();
          }
        })
        .catch((error) => {});
    },
    getSubscription() {
      this.doLoading();
      // alert(this.trackingId);
      if (this.trackingId != "") {
        let payload = {
          subscriptionId: this.trackingId,
        };
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Tracking/globalTracking.php`,
          data: JSON.stringify(payload),
          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };

        axios(options)
          .then((result) => {
            this.isLoading = false;
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              // console.log("Result => ", JSON.parse(data.data));
              data.data = JSON.parse(data.data);
              if (data.data.containershipments.length > 0) {
                this.getContainerNoData.forEach((element) => {
                  data.data.containershipments.forEach((cont_elem) => {
                    if (cont_elem.container_number == element.containerNo) {
                      element["vesselName"] = cont_elem.leg1_vessel
                        ? cont_elem.leg1_vessel["name"]
                        : "";
                      element["vesselVoyage"] = cont_elem.leg1_voyage
                        ? cont_elem.leg1_voyage
                        : "";
                      element["vesselEtd"] =
                        cont_elem.pol_vsldeparture_planned_initial
                          ? cont_elem.pol_vsldeparture_planned_initial
                          : "";
                      element = element;
                      this.getContainerNoData.push(element);
                    }
                  });
                });

                this.getContainerNoData = [...new Set(this.getContainerNoData)];
                // console.log("this.getContainerNoData Priyanshu SIngh=>",this.getContainerNoData)
              }
            }
          })
          .catch((error) => {
            this.doLoadingClose();
            console.log("Err => ", error);
          });
      }
    },

    getTrackingDetails(allModuleId) {
      let new_data = {
        allModuleId: allModuleId,
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Tracking/getSubscriptionTrackingDetails.php`,
        data: JSON.stringify(new_data),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;

          if (status == 200 && data) {
            if (data.BIdType && data.BIdType.length > 0) {
              this.$sessionsStorage.set("trackingId", data.BIdType[0].id);
              this.trackingId = data.BIdType[0].id;
            } else {
              this.trackingId = "";
            }
            this.getSubscription();
          }
        })
        .catch((error) => {});
    },
    addNew() {
      this.$router.push({
        path: "/client/addClient",
      });
    },
    deleteData(item) {
      this.deleteId = item.railOutTableId;

      this.alert.content = "Are you sure you want to delete this data?";
      this.$refs["addPop6"].open();
    },

    previousFFView() {
      // if (this.stuffingType == "factoryStuffing") {
      //   this.$router.push({
      //     path: "/freightForward/ffExecution"
      //   });
      // } else {
      //   this.$router.push({
      //     path: "/freightForward/ffexecutionWareHouse"
      //   });
      // }
      window.history.go(-1);
    },

    showOverflow() {
      if (this.showVisible == false) {
        this.showVisible = true;
        $("#showVisibility").css("overflow", "visible");
      } else {
        this.showVisible = false;
        $("#showVisibility").css("overflow", "hidden");
      }
    },

    getServicesData() {
      this.showSegmentArray = [
        {
          value: "Freight_Forwarding",
          show: "Freight Forwarding(FF)",
          flex: "20",
        },
        {
          value: "Customs_Clearance",
          show: "Customs Clearance(CC)",
          flex: "20",
        },
        {
          value: "Transportation",
          show: "Transportation(TPT)",
          flex: "20",
        },

        {
          value: "All",
          show: "All",
          flex: "15",
        },
      ];
    },
  },
};
</script>
<style scoped>
.md-direction-bottom-right {
  width: 18% !important;
}
.md-sidenav .md-sidenav-content:hover {
  width: 100% !important;
  /* transition: 0.3s; */
}
.md-list .md-theme-default:hover {
  width: 100% !important;
}
.center {
  text-align: center;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
.md-list-item-expand.md-active {
  position: relative;
  overflow: visible;
}
</style>


// WEBPACK FOOTER //
// newHandoverToRail.vue?b5558b64